import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';

import {popAlert} from 'ondemand/actions/alert';
import Alert from 'ondemand/components/Alert';

class AlertStack extends React.Component {
  static displayName = 'AlertStack';

  static propTypes = {
    alerts: PropTypes.arrayOf(PropTypes.shape({
      level: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      target: PropTypes.string,
      icon: PropTypes.node,
      closeIcon: PropTypes.node,
      hideClose: PropTypes.bool,
      onClick: PropTypes.func,
      onClose: PropTypes.func,
    })).isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  render() {
    if (this.props.alerts.length === 0) return null;

    // Only render the last alert
    const {
      level,
      title,
      subtitle,
      target,
      icon,
      closeIcon,
      hideClose,
      onClick,
      onClose,
    } = this.props.alerts[this.props.alerts.length - 1];
    const _onClose = hideClose ? null : () => {
      if (onClose) {
        onClose();
      }
      this.props.dispatch(popAlert());
    };

    // eslint-disable-next-line no-unused-vars
    let oc = onClick || null;
    oc = !oc && !target ? null : () => {
      this.props.dispatch(popAlert());
      this.props.dispatch(push(target));
    };

    return (
      <Alert
        data-id="alert"
        level={level}
        title={title}
        subtitle={subtitle}
        onClick={oc}
        onClose={_onClose}
        icon={icon}
        closeIcon={closeIcon}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  alerts: state.alert.items,
});

export default connect(mapStateToProps)(AlertStack);



// WEBPACK FOOTER //
// ./src/ondemand/containers/AlertStack.js